import { debounce } from "@/helpers/helpers";

export const addPostMixin = {
  data() {
    return {
      hidePosition: true,
      menu: false,
      loading: {
        view: false,
        list: false
      },
      loaded: false,
      date: [null, null],
      postsSearchInputValue: "",
      posts: [],
      totalCount: 0,
      page: 1,
      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      insightsData: {},
      showDeleted: false
    };
  },
  computed: {
    params() {
      return {
        page: this.page,
        perPage: this.perPage,
        date: this.date,
        query: this.postsSearchInputValue,
        showDeleted: this.showDeleted
      };
    }
  },
  methods: {
    onPostsSearch: debounce(async function() {
      this.loading.list = true;
      this.page = 1;
      await this.fetchPosts();
      this.loading.list = false;
    }, 500),

    async handleChange({ page, perPage }) {
      this.loading.list = true;
      this.page = page || this.page;
      this.perPage = perPage || this.perPage;
      await this.fetchPosts();
      this.loading.list = false;
    }
  }
};
